import { ReactNode } from 'react';
import cn from 'classnames';

import styles from './index.module.css';

type Props = {
  className?: string;
  children: ReactNode;
};

export const FormFields = ({ className, children }: Props) => {
  return <div className={cn(styles.fields, className)}>{children}</div>;
};

export const FormFieldsHalf = ({ className, children }: Props) => {
  return <div className={cn(styles.fieldsHalf, className)}>{children}</div>;
};
